export default __webpack_public_path__ + "a56980a3855fbe5445aa173cd58a2daa.png";